// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { buyItem, cancelMarketTransaction, confirmMarketProfile, debugSession, fakeLogin, getBrRank, getCategories, getChannel, getCharacter, getCharacterHards, getCharacterRoles, getCharacters, getCharacterSynergy, getComboCharacters, getCsRank, getFeedbackCategories, getGenders, getGenres, getItem, getItems, getLanguages, getMarketItems, getMarketProfile, getMarketRegion, getMarketTransactions, getMe, getParams, getPlatforms, getPrimeLevel, getProfile, getRares, getTags, getTransify, getVaultProfile, getVaultRank, getVaultRanks, getWallet, getWeapons, login, loginCallback, type Options, react, redirectLogin, redirectLogout, sellItem, submitFeedback, timesync } from '../sdk.gen';
import type { BuyItemData, BuyItemResponse, CancelMarketTransactionData, CancelMarketTransactionResponse, ConfirmMarketProfileData, ConfirmMarketProfileResponse, DebugSessionData, DebugSessionResponse, FakeLoginData, FakeLoginResponse, GetBrRankData, GetBrRankResponse, GetCategoriesData, GetCategoriesResponse, GetChannelData, GetChannelResponse, GetCharacterData, GetCharacterHardsData, GetCharacterHardsResponse, GetCharacterResponse, GetCharacterRolesData, GetCharacterRolesResponse, GetCharactersData, GetCharactersResponse, GetCharacterSynergyData, GetCharacterSynergyResponse, GetComboCharactersData, GetComboCharactersResponse, GetCsRankData, GetCsRankResponse, GetFeedbackCategoriesData, GetFeedbackCategoriesResponse, GetGendersData, GetGendersResponse, GetGenresData, GetGenresResponse, GetItemData, GetItemResponse, GetItemsData, GetItemsResponse, GetLanguagesData, GetLanguagesResponse, GetMarketItemsData, GetMarketItemsResponse, GetMarketProfileData, GetMarketProfileResponse, GetMarketRegionData, GetMarketRegionResponse, GetMarketTransactionsData, GetMarketTransactionsResponse, GetMeData, GetMeResponse, GetParamsData, GetParamsResponse, GetPlatformsData, GetPlatformsResponse, GetPrimeLevelData, GetPrimeLevelResponse, GetProfileData, GetProfileResponse, GetRaresData, GetRaresResponse, GetTagsData, GetTagsResponse, GetTransifyData, GetTransifyResponse, GetVaultProfileData, GetVaultProfileResponse, GetVaultRankData, GetVaultRankResponse, GetVaultRanksData, GetVaultRanksResponse, GetWalletData, GetWalletResponse, GetWeaponsData, GetWeaponsResponse, LoginCallbackData, LoginData, LoginResponse, ReactData, ReactResponse, RedirectLoginData, RedirectLogoutData, SellItemData, SellItemResponse, SubmitFeedbackData, SubmitFeedbackResponse, TimesyncData, TimesyncResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getParamsQueryKey = (options: Options<GetParamsData>) => createQueryKey('getParams', options);

/**
 * Common params
 */
export const getParamsOptions = (options: Options<GetParamsData>) => queryOptions<GetParamsResponse, DefaultError, GetParamsResponse, ReturnType<typeof getParamsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getParams({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getParamsQueryKey(options)
});

/**
 * Timesync JSON-RPC
 */
export const timesyncMutation = (options?: Partial<Options<TimesyncData>>): UseMutationOptions<TimesyncResponse, DefaultError, Options<TimesyncData>> => {
    const mutationOptions: UseMutationOptions<TimesyncResponse, DefaultError, Options<TimesyncData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await timesync({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMeQueryKey = (options?: Options<GetMeData>) => createQueryKey('getMe', options);

export const getMeOptions = (options?: Options<GetMeData>) => queryOptions<GetMeResponse, DefaultError, GetMeResponse, ReturnType<typeof getMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeQueryKey(options)
});

export const getProfileQueryKey = (options?: Options<GetProfileData>) => createQueryKey('getProfile', options);

export const getProfileOptions = (options?: Options<GetProfileData>) => queryOptions<GetProfileResponse, DefaultError, GetProfileResponse, ReturnType<typeof getProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProfileQueryKey(options)
});

/**
 * Get items
 */
export const getItemsMutation = (options?: Partial<Options<GetItemsData>>): UseMutationOptions<GetItemsResponse, DefaultError, Options<GetItemsData>> => {
    const mutationOptions: UseMutationOptions<GetItemsResponse, DefaultError, Options<GetItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getItemQueryKey = (options: Options<GetItemData>) => createQueryKey('getItem', options);

/**
 * Get item by id
 */
export const getItemOptions = (options: Options<GetItemData>) => queryOptions<GetItemResponse, DefaultError, GetItemResponse, ReturnType<typeof getItemQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getItem({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getItemQueryKey(options)
});

/**
 * React to item
 */
export const reactMutation = (options?: Partial<Options<ReactData>>): UseMutationOptions<ReactResponse, DefaultError, Options<ReactData>> => {
    const mutationOptions: UseMutationOptions<ReactResponse, DefaultError, Options<ReactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await react({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCategoriesQueryKey = (options?: Options<GetCategoriesData>) => createQueryKey('getCategories', options);

/**
 * Get categories
 */
export const getCategoriesOptions = (options?: Options<GetCategoriesData>) => queryOptions<GetCategoriesResponse, DefaultError, GetCategoriesResponse, ReturnType<typeof getCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCategoriesQueryKey(options)
});

export const getGenresQueryKey = (options?: Options<GetGenresData>) => createQueryKey('getGenres', options);

/**
 * Get genres
 */
export const getGenresOptions = (options?: Options<GetGenresData>) => queryOptions<GetGenresResponse, DefaultError, GetGenresResponse, ReturnType<typeof getGenresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGenres({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGenresQueryKey(options)
});

export const getRaresQueryKey = (options?: Options<GetRaresData>) => createQueryKey('getRares', options);

/**
 * Get rares
 */
export const getRaresOptions = (options?: Options<GetRaresData>) => queryOptions<GetRaresResponse, DefaultError, GetRaresResponse, ReturnType<typeof getRaresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRares({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRaresQueryKey(options)
});

export const getGendersQueryKey = (options?: Options<GetGendersData>) => createQueryKey('getGenders', options);

/**
 * Get genders
 */
export const getGendersOptions = (options?: Options<GetGendersData>) => queryOptions<GetGendersResponse, DefaultError, GetGendersResponse, ReturnType<typeof getGendersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGenders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGendersQueryKey(options)
});

export const getTagsQueryKey = (options?: Options<GetTagsData>) => createQueryKey('getTags', options);

/**
 * Get tags
 */
export const getTagsOptions = (options?: Options<GetTagsData>) => queryOptions<GetTagsResponse, DefaultError, GetTagsResponse, ReturnType<typeof getTagsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTagsQueryKey(options)
});

export const getWeaponsQueryKey = (options?: Options<GetWeaponsData>) => createQueryKey('getWeapons', options);

/**
 * Get weapons
 */
export const getWeaponsOptions = (options?: Options<GetWeaponsData>) => queryOptions<GetWeaponsResponse, DefaultError, GetWeaponsResponse, ReturnType<typeof getWeaponsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWeapons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWeaponsQueryKey(options)
});

export const getChannelQueryKey = (options: Options<GetChannelData>) => createQueryKey('getChannel', options);

/**
 * Get channel
 */
export const getChannelOptions = (options: Options<GetChannelData>) => queryOptions<GetChannelResponse, DefaultError, GetChannelResponse, ReturnType<typeof getChannelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getChannel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getChannelQueryKey(options)
});

export const getBrRankQueryKey = (options: Options<GetBrRankData>) => createQueryKey('getBrRank', options);

export const getBrRankOptions = (options: Options<GetBrRankData>) => queryOptions<GetBrRankResponse, DefaultError, GetBrRankResponse, ReturnType<typeof getBrRankQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBrRank({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBrRankQueryKey(options)
});

export const getCsRankQueryKey = (options: Options<GetCsRankData>) => createQueryKey('getCsRank', options);

export const getCsRankOptions = (options: Options<GetCsRankData>) => queryOptions<GetCsRankResponse, DefaultError, GetCsRankResponse, ReturnType<typeof getCsRankQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCsRank({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCsRankQueryKey(options)
});

export const getPrimeLevelQueryKey = (options: Options<GetPrimeLevelData>) => createQueryKey('getPrimeLevel', options);

export const getPrimeLevelOptions = (options: Options<GetPrimeLevelData>) => queryOptions<GetPrimeLevelResponse, DefaultError, GetPrimeLevelResponse, ReturnType<typeof getPrimeLevelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPrimeLevel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPrimeLevelQueryKey(options)
});

export const redirectLoginQueryKey = (options?: Options<RedirectLoginData>) => createQueryKey('redirectLogin', options);

/**
 * Redirect to login url
 */
export const redirectLoginOptions = (options?: Options<RedirectLoginData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof redirectLoginQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await redirectLogin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: redirectLoginQueryKey(options)
});

/**
 * Login with a token
 */
export const loginMutation = (options?: Partial<Options<LoginData>>): UseMutationOptions<LoginResponse, DefaultError, Options<LoginData>> => {
    const mutationOptions: UseMutationOptions<LoginResponse, DefaultError, Options<LoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await login({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * (Test) Fake a login session
 */
export const fakeLoginMutation = (options?: Partial<Options<FakeLoginData>>): UseMutationOptions<FakeLoginResponse, DefaultError, Options<FakeLoginData>> => {
    const mutationOptions: UseMutationOptions<FakeLoginResponse, DefaultError, Options<FakeLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fakeLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const debugSessionQueryKey = (options?: Options<DebugSessionData>) => createQueryKey('debugSession', options);

/**
 * (Test) Debug current session
 */
export const debugSessionOptions = (options?: Options<DebugSessionData>) => queryOptions<DebugSessionResponse, DefaultError, DebugSessionResponse, ReturnType<typeof debugSessionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await debugSession({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: debugSessionQueryKey(options)
});

export const loginCallbackQueryKey = (options: Options<LoginCallbackData>) => createQueryKey('loginCallback', options);

/**
 * Login callback
 */
export const loginCallbackOptions = (options: Options<LoginCallbackData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof loginCallbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await loginCallback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: loginCallbackQueryKey(options)
});

export const redirectLogoutQueryKey = (options?: Options<RedirectLogoutData>) => createQueryKey('redirectLogout', options);

/**
 * Redirect to logout url
 */
export const redirectLogoutOptions = (options?: Options<RedirectLogoutData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof redirectLogoutQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await redirectLogout({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: redirectLogoutQueryKey(options)
});

export const getPlatformsQueryKey = (options?: Options<GetPlatformsData>) => createQueryKey('getPlatforms', options);

/**
 * Get all platforms
 */
export const getPlatformsOptions = (options?: Options<GetPlatformsData>) => queryOptions<GetPlatformsResponse, DefaultError, GetPlatformsResponse, ReturnType<typeof getPlatformsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlatforms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlatformsQueryKey(options)
});

export const getTransifyQueryKey = (options?: Options<GetTransifyData>) => createQueryKey('getTransify', options);

export const getTransifyOptions = (options?: Options<GetTransifyData>) => queryOptions<GetTransifyResponse, DefaultError, GetTransifyResponse, ReturnType<typeof getTransifyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTransify({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTransifyQueryKey(options)
});

export const getLanguagesQueryKey = (options?: Options<GetLanguagesData>) => createQueryKey('getLanguages', options);

export const getLanguagesOptions = (options?: Options<GetLanguagesData>) => queryOptions<GetLanguagesResponse, DefaultError, GetLanguagesResponse, ReturnType<typeof getLanguagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLanguages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLanguagesQueryKey(options)
});

export const getFeedbackCategoriesQueryKey = (options?: Options<GetFeedbackCategoriesData>) => createQueryKey('getFeedbackCategories', options);

export const getFeedbackCategoriesOptions = (options?: Options<GetFeedbackCategoriesData>) => queryOptions<GetFeedbackCategoriesResponse, DefaultError, GetFeedbackCategoriesResponse, ReturnType<typeof getFeedbackCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFeedbackCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFeedbackCategoriesQueryKey(options)
});

export const submitFeedbackMutation = (options?: Partial<Options<SubmitFeedbackData>>): UseMutationOptions<SubmitFeedbackResponse, DefaultError, Options<SubmitFeedbackData>> => {
    const mutationOptions: UseMutationOptions<SubmitFeedbackResponse, DefaultError, Options<SubmitFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getVaultRanksQueryKey = (options?: Options<GetVaultRanksData>) => createQueryKey('getVaultRanks', options);

export const getVaultRanksOptions = (options?: Options<GetVaultRanksData>) => queryOptions<GetVaultRanksResponse, DefaultError, GetVaultRanksResponse, ReturnType<typeof getVaultRanksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getVaultRanks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getVaultRanksQueryKey(options)
});

export const getVaultRankQueryKey = (options: Options<GetVaultRankData>) => createQueryKey('getVaultRank', options);

export const getVaultRankOptions = (options: Options<GetVaultRankData>) => queryOptions<GetVaultRankResponse, DefaultError, GetVaultRankResponse, ReturnType<typeof getVaultRankQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getVaultRank({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getVaultRankQueryKey(options)
});

export const getVaultProfileQueryKey = (options?: Options<GetVaultProfileData>) => createQueryKey('getVaultProfile', options);

export const getVaultProfileOptions = (options?: Options<GetVaultProfileData>) => queryOptions<GetVaultProfileResponse, DefaultError, GetVaultProfileResponse, ReturnType<typeof getVaultProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getVaultProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getVaultProfileQueryKey(options)
});

export const getCharacterRolesQueryKey = (options?: Options<GetCharacterRolesData>) => createQueryKey('getCharacterRoles', options);

/**
 * Get character roles
 */
export const getCharacterRolesOptions = (options?: Options<GetCharacterRolesData>) => queryOptions<GetCharacterRolesResponse, DefaultError, GetCharacterRolesResponse, ReturnType<typeof getCharacterRolesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCharacterRoles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCharacterRolesQueryKey(options)
});

export const getCharacterHardsQueryKey = (options?: Options<GetCharacterHardsData>) => createQueryKey('getCharacterHards', options);

/**
 * Get character hards
 */
export const getCharacterHardsOptions = (options?: Options<GetCharacterHardsData>) => queryOptions<GetCharacterHardsResponse, DefaultError, GetCharacterHardsResponse, ReturnType<typeof getCharacterHardsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCharacterHards({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCharacterHardsQueryKey(options)
});

/**
 * Get Characters
 */
export const getCharactersMutation = (options?: Partial<Options<GetCharactersData>>): UseMutationOptions<GetCharactersResponse, DefaultError, Options<GetCharactersData>> => {
    const mutationOptions: UseMutationOptions<GetCharactersResponse, DefaultError, Options<GetCharactersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getCharacters({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCharacterQueryKey = (options: Options<GetCharacterData>) => createQueryKey('getCharacter', options);

/**
 * Get character by id
 */
export const getCharacterOptions = (options: Options<GetCharacterData>) => queryOptions<GetCharacterResponse, DefaultError, GetCharacterResponse, ReturnType<typeof getCharacterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCharacter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCharacterQueryKey(options)
});

/**
 * Get Combo Characters
 */
export const getComboCharactersMutation = (options?: Partial<Options<GetComboCharactersData>>): UseMutationOptions<GetComboCharactersResponse, DefaultError, Options<GetComboCharactersData>> => {
    const mutationOptions: UseMutationOptions<GetComboCharactersResponse, DefaultError, Options<GetComboCharactersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getComboCharacters({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get character synergy
 */
export const getCharacterSynergyMutation = (options?: Partial<Options<GetCharacterSynergyData>>): UseMutationOptions<GetCharacterSynergyResponse, DefaultError, Options<GetCharacterSynergyData>> => {
    const mutationOptions: UseMutationOptions<GetCharacterSynergyResponse, DefaultError, Options<GetCharacterSynergyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getCharacterSynergy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMarketRegionQueryKey = (options?: Options<GetMarketRegionData>) => createQueryKey('getMarketRegion', options);

/**
 * Get market region config
 */
export const getMarketRegionOptions = (options?: Options<GetMarketRegionData>) => queryOptions<GetMarketRegionResponse, DefaultError, GetMarketRegionResponse, ReturnType<typeof getMarketRegionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketRegion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketRegionQueryKey(options)
});

export const getWalletQueryKey = (options?: Options<GetWalletData>) => createQueryKey('getWallet', options);

/**
 * Get user wallet
 */
export const getWalletOptions = (options?: Options<GetWalletData>) => queryOptions<GetWalletResponse, DefaultError, GetWalletResponse, ReturnType<typeof getWalletQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWallet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWalletQueryKey(options)
});

export const getMarketProfileQueryKey = (options?: Options<GetMarketProfileData>) => createQueryKey('getMarketProfile', options);

/**
 * Get market profile
 */
export const getMarketProfileOptions = (options?: Options<GetMarketProfileData>) => queryOptions<GetMarketProfileResponse, DefaultError, GetMarketProfileResponse, ReturnType<typeof getMarketProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketProfileQueryKey(options)
});

/**
 * Confirm to become market participant
 */
export const confirmMarketProfileMutation = (options?: Partial<Options<ConfirmMarketProfileData>>): UseMutationOptions<ConfirmMarketProfileResponse, DefaultError, Options<ConfirmMarketProfileData>> => {
    const mutationOptions: UseMutationOptions<ConfirmMarketProfileResponse, DefaultError, Options<ConfirmMarketProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmMarketProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMarketItemsQueryKey = (options?: Options<GetMarketItemsData>) => createQueryKey('getMarketItems', options);

/**
 * Get item list
 */
export const getMarketItemsOptions = (options?: Options<GetMarketItemsData>) => queryOptions<GetMarketItemsResponse, DefaultError, GetMarketItemsResponse, ReturnType<typeof getMarketItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketItemsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getMarketItemsInfiniteQueryKey = (options?: Options<GetMarketItemsData>): QueryKey<Options<GetMarketItemsData>> => createQueryKey('getMarketItems', options, true);

/**
 * Get item list
 */
export const getMarketItemsInfiniteOptions = (options?: Options<GetMarketItemsData>) => infiniteQueryOptions<GetMarketItemsResponse, DefaultError, InfiniteData<GetMarketItemsResponse>, QueryKey<Options<GetMarketItemsData>>, number | Pick<QueryKey<Options<GetMarketItemsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetMarketItemsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getMarketItems({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketItemsInfiniteQueryKey(options)
});

/**
 * Request to sell an item
 */
export const sellItemMutation = (options?: Partial<Options<SellItemData>>): UseMutationOptions<SellItemResponse, DefaultError, Options<SellItemData>> => {
    const mutationOptions: UseMutationOptions<SellItemResponse, DefaultError, Options<SellItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sellItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request to buy an item
 */
export const buyItemMutation = (options?: Partial<Options<BuyItemData>>): UseMutationOptions<BuyItemResponse, DefaultError, Options<BuyItemData>> => {
    const mutationOptions: UseMutationOptions<BuyItemResponse, DefaultError, Options<BuyItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await buyItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get transaction list
 */
export const getMarketTransactionsMutation = (options?: Partial<Options<GetMarketTransactionsData>>): UseMutationOptions<GetMarketTransactionsResponse, DefaultError, Options<GetMarketTransactionsData>> => {
    const mutationOptions: UseMutationOptions<GetMarketTransactionsResponse, DefaultError, Options<GetMarketTransactionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getMarketTransactions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request to cancel a transaction
 */
export const cancelMarketTransactionMutation = (options?: Partial<Options<CancelMarketTransactionData>>): UseMutationOptions<CancelMarketTransactionResponse, DefaultError, Options<CancelMarketTransactionData>> => {
    const mutationOptions: UseMutationOptions<CancelMarketTransactionResponse, DefaultError, Options<CancelMarketTransactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelMarketTransaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
